import Vue from 'vue'
import CpComponents from '@peiyou/xh-cp-components';
import xiaohoucodeUi from '@peiyou/xh-xiaohoucode-ui';

import App from './App.vue'
import {router} from './router/index';
import store from '@/store';
import vSelect from 'vue-select';
import showMessage from './common/message';
import VueLoading from 'vue-loading-overlay';
import vueDirectiveTooltip from 'vue-directive-tooltip';
// import DrComponents from 'houboshi';
import DrComponents from '@peiyou/xh-houboshi';

// import ClientMonitor from 'skywalking-client-js';
import { Loading,Pagination,Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@peiyou/xh-cp-components/lib/cp-components.css';
import '@peiyou/xh-xiaohoucode-ui/lib/xiaohoucode-ui.css';

import './assets/less/reset.less';
import 'vue-select/dist/vue-select.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import '@/assets/less/icon.less';
import config from '../package.json';

import vmLoading from './components/loading/index';

const { VUE_APP_ENV } = process.env
 
const host = VUE_APP_ENV === 'production' 
  ? 'rest.xiaohoucode.com'
  : (VUE_APP_ENV === 'preview'
  ? 'rest-pre.xiaohoucode.com'
  : 'test-rest.xiaohoucode.com')

CpComponents.changeHost(host);
DrComponents.changeHost(host);

// ClientMonitor.register({
//   service: process.env.VUE_APP_SERVICE_NAME,
//   pagePath: 'home',
//   serviceVersion: config.version,
//   vue: Vue,
//   enableSPA: true,
// });

Vue.prototype.$message = showMessage;
Vue.prototype.$elMessage = Message;
Vue.component('v-select', vSelect);
Vue.use(CpComponents);
Vue.use(VueLoading);
Vue.use(Pagination)
Vue.use(Loading.directive);
Vue.use(vueDirectiveTooltip);
Vue.use(DrComponents);
Vue.use(xiaohoucodeUi);
Vue.use(vmLoading);

const initVue = function () {
  new Vue({
    store,
    router,
    render: h => h(App),
  }).$mount('#app');
}

let hash = window.location.hash;
if(hash.indexOf('jslist') !== -1){
  store.dispatch('initUserInfo',true)
  initVue()
}else{
  store.dispatch('init')
    .then(()=>{
    initVue()
    })
}


// }

